import React from "react";
import { createFileRoute } from '@tanstack/react-router'
import {
  Container,
  Heading,
} from "@chakra-ui/react"
export const Route = createFileRoute("/_layout/provider/providerclients/")({
  component: ProviderClients
})
import { useNavigate } from "@tanstack/react-router"

function ProviderClients() {
  const navigate = useNavigate({ from: Route.fullPath });

  React.useEffect(() => {
    const storedProviderId = sessionStorage.getItem("selectedProviderId");
    if (storedProviderId) {
      navigate({ to: `/provider/providerclients/${storedProviderId}`, search: { page: 1 } });
      return
    }

    navigate({ to: "/providers", search: { page: 1 } })
  }, [navigate]);

  return (
    <Container maxW="full">
      <Heading size="lg" pt={12}>
        Provider Clients Management
      </Heading>
    </Container>
  )
}